import { render } from "./NewWeek.vue?vue&type=template&id=f26ed9e2"
import script from "./NewWeek.vue?vue&type=script&lang=js"
export * from "./NewWeek.vue?vue&type=script&lang=js"

import "./NewWeek.vue?vue&type=style&index=0&id=f26ed9e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__